import { useState } from "react";

import { EmailValidate, FormValidate } from "../../../components/formValidate";
import TextField from "../../../components/inputs/textfield";
import Snackbar from "../../../components/snackbar/snackbar";
import "./admin.css";
import { companyLogin, forgotPassword } from "./auth.api";
import jwtDecode from "jwt-decode";
let required = ["email", "password"];
export default function Companylogin(props) {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState({});
  const [submit, setSubmit] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [showForgot, setShowForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");

  const handleChange = (e) => {
    let erroremail = false;

    if (e.target.name === "email") {
      erroremail = !EmailValidate(e.target.value);

      setError({ ...error, email: erroremail });
    }
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleSubmit = (e) => {
    setSubmit(true);
    const error = FormValidate(formData, required);
    setError(error);
    e.preventDefault();

    if (Object.keys(error).length === 0) {
      companyLogin(formData)
        .then((res) => {
          setSubmit(false);
          sessionStorage.setItem("token", res.token);
          
          // Decode token to check user type
          const decodedToken = jwtDecode(res.token);
          const userType = decodedToken.user_type || decodedToken.user?.user_type;
          
          // Use appropriate login method based on user type
          // Admin users (user_type 1, 2, 23) use adminLogin
          // Company users (user_type 0, 4) and others use login
          if (userType === 1 || userType === 2 || userType === 23) {
            props.adminLogin(res.token);
            props.history.push({
              pathname: "/admin-dashboard",
            });
          } else {
            props.login(res.token);
            props.history.push({
              pathname: "/dashboard",
            });
          }
        })
        .catch((error) => {
          setSubmit(false);

          setSnackMessage(error.response.data.message);
          setIsSnackError(true);
          setSnackOpen(true);
        });
    } else {
      setSubmit(false);
    }
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
  };
  const handleForgotPassword = () => {
    if (!EmailValidate(forgotEmail)) {
      setSnackMessage("Please enter a valid email");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }

    forgotPassword({ email: forgotEmail })
      .then((res) => {
        setSnackMessage("Password reset instructions sent to your email.");
        setIsSnackError(false);
        setSnackOpen(true);
        setShowForgot(false);
      })
      .catch((error) => {
        setSnackMessage(
          error?.response?.data?.message || "Failed to process request"
        );
        setIsSnackError(true);
        setSnackOpen(true);
      });
  };
  const handleForgot = () => {
    setShowForgot(!showForgot);
  };
  return (
    <div className="admin-login-page">
      <div className="">
        <img
          src="/resources/logo/logo.png"
          alt=""
          className="admin-login-logo"
        />
      </div>
      <div className="admin-login-container ">
        {!showForgot ? (
          <>
            <div className="admin-login-title">COMPANY</div>
            <form
              className=""
              autoComplete="off"
              noValidate
              onSubmit={handleSubmit}
            >
              <div className="login-input">
                <TextField
                  {...props}
                  type="text"
                  required
                  onChange={handleChange}
                  label="Username"
                  error={error.email}
                  name="email"
                  placeholder="Enter your username"
                />
              </div>
              <div className="login-input">
                <TextField
                  {...props}
                  label="Password"
                  type="password"
                  required
                  name="password"
                  error={error.password}
                  onChange={handleChange}
                  placeholder="Enter your password"
                />
              </div>

              <div className="butnCnt">
                <button
                  disabled={submit}
                  {...props}
                  className="btn btn-primary"
                  type="submit"
                >
                  Login
                </button>
              </div>
            </form>
          </>
        ) : (
          <>
            <div className="admin-login-title">FORGOT PASSWORD</div>
            <form autoComplete="off" noValidate>
              <div className="login-input">
                <TextField
                  type="text"
                  required
                  onChange={(e) => setForgotEmail(e.target.value)}
                  label="Enter your email"
                  name="forgotEmail"
                  placeholder="Email"
                />
              </div>
              <div className="text-end mt-2 forgot-link">
                <span
                  style={{
                    cursor: "pointer",
                    color: "#007bff",
                    fontSize: "14px",
                  }}
                  onClick={handleForgot}
                >
                  Login
                </span>
              </div>

              <div className="butnCnt">
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={handleForgotPassword}
                >
                  submit
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
